import React from "react";

import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/ui/spinner";

type Props = {
  isOpen: boolean;
  conversationTitle: string;
  onCancel: () => void;
  onDelete: () => void;
  isDeleting: boolean;
};

export function DeleteConversationModal({
  isOpen,
  conversationTitle,
  onCancel,
  onDelete,
  isDeleting
}: Props) {
  return (
    <AlertDialog
      open={isOpen}
      onOpenChange={(next) => {
        if (!next && !isDeleting) onCancel();
      }}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Delete Conversation?</AlertDialogTitle>
          <AlertDialogDescription className="flex flex-col gap-1">
            <span className="text-fg">
              This will permanently delete{" "}
              <span className="font-medium">
                {conversationTitle || "Untitled conversation"}
              </span>
              .
            </span>
            <span className="text-sm">This action cannot be undone.</span>
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <Button variant="secondary" onClick={onCancel} disabled={isDeleting}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onDelete}
            disabled={isDeleting}
            aria-busy={isDeleting || undefined}
          >
            {isDeleting ? <Spinner className="size-3.5" /> : null}
            Delete
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

export default DeleteConversationModal;
